import React from 'react'
import { businessHero } from './content'
import type { Lang } from './types'

interface BusinessHeroV2Props {
  currentLang: Lang
}

/**
 * BusinessHeroV2
 * Full-bleed image hero with bottom-aligned title — mirrors baristamap /pages/business hero.
 */
const BusinessHeroV2: React.FC<BusinessHeroV2Props> = ({ currentLang }) => {
  return (
    <section className="relative h-[70vh] min-h-[480px] w-full overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src={businessHero.image}
          alt={businessHero.imageAlt[currentLang]}
          className="h-full w-full object-cover"
        />
        {/* Subtle dark wash + bottom gradient for title legibility */}
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/55 to-transparent" />
      </div>

      {/* Title — pinned bottom-left, baristamap signature placement */}
      <div className="relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-12 md:px-10 md:pb-16">
        <h1
          className="text-white"
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontWeight: 400,
            fontSize: 'clamp(2.25rem, 5vw, 4rem)',
            letterSpacing: '0.02em',
            lineHeight: 1.1,
          }}
        >
          {businessHero.title[currentLang]}
        </h1>
      </div>
    </section>
  )
}

export default BusinessHeroV2
